import styled from '@emotion/styled'
import { Button, NavLink, Row } from 'react-bootstrap'

const darkGray = '#5a5555'
const slateGray = '#7a858c'
const softSlate = '#9fa0a3'
const paleBlue = '#bbccd8'
const teal = '#076698'
const navyBlue = '#054465'
export const deepNavy = '#06557E'
const darkSlateGray = '#151314'
const fontFamily = 'Poppins, sans-serif'
const applicationProfileUpdateBackground = '#f8f8fb'

export const ApplicationProfileUpdateContainer = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: applicationProfileUpdateBackground,
})

export const ProfileSectionItemCardWrapper = styled('div')({
  boxSizing: 'border-box',
  display: 'flex',
  flex: '0 0 auto',
  flexDirection: 'row',
  gap: '8px',
  justifyContent: 'space-between',
})

export const ProfileSectionItemHeader = styled('p')({
  padding: 0,
  font: `600 16px ${fontFamily}`,
  color: darkGray,
  textTransform: 'capitalize',
})

export const JobCardWrapper = styled('div')({
  display: 'flex',
  flex: '0 0 auto',
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'flex-start',
  marginTop: '24px',
})

export const JobNavigation = styled('div')({
  display: 'flex',
  flex: '0 0 auto',
  flexDirection: 'row',
  alignItems: 'end',
  alignSelf: 'end',
  justifyContent: 'end',
  marginTop: '24px',
})

export const JobItem = styled('div')({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  width: '100%',
  height: '112px',
  marginTop: '24px',
  background: 'white',
  borderLeft: `3px solid ${paleBlue}`,
  borderRadius: '6px',
  boxShadow: '0px 10px 20px rgba(18, 38, 63, 0.03)',
})

export const JobItemDetails = styled('div')({
  boxSizing: 'border-box',
  flex: '0 0 auto',
  width: '83.72%',
  padding: '20px 27px',
})

export const JobTitle = styled('p')({
  padding: 0,
  margin: 0,
  fontFamily,
  fontSize: 14,
  lineHeight: '20.5px',
  fontWeight: 600,
  color: darkGray,
  whiteSpace: 'pre-wrap',
})

export const CompanyInfoText = styled('p')({
  padding: 0,
  margin: 0,
  marginTop: '6px',
  font: `400 14px ${fontFamily}`,
  color: slateGray,
  whiteSpace: 'pre-wrap',
})

export const JobProfileSectionItemDurationText = styled('p')({
  padding: 0,
  margin: 0,
  marginTop: '6px',
  font: `400 12px ${fontFamily}`,
  color: softSlate,
  whiteSpace: 'pre-wrap',
})

export const JobDetailsLink = styled(Button)(
  ({ color = softSlate, hovercolor = slateGray }) => ({
    boxSizing: 'border-box',
    flex: '0 0 auto',
    margin: '12px',
    marginRight: 'auto',
    background: 'transparent',
    border: 'none',
    color,
    '&:hover': {
      background: 'transparent',
      color: hovercolor,
    },
    '&:active': {
      background: 'transparent !important',
      color: `${color} !important`,
    },
  }),
)

export const ProfileSectionTitleTextStyle = styled('p')({
  padding: 0,
  paddingRight: '15px',
  paddingLeft: '15px',
  margin: 0,
  font: `600 18px ${fontFamily}`,
  color: teal,
  marginBottom: '10px',
})

export const HeaderTitleBold = styled('span')({
  font: `600 18px ${fontFamily}`,
  color: darkSlateGray,
})

export const HighlightedHeading = styled('span')({
  font: `600 18px ${fontFamily}`,
  color: teal,
  textDecorationLine: 'underline',
})

export const PersonalInfoLink = styled(NavLink)(({ isActive = false }) => ({
  display: 'flex',
  background: isActive ? '#bfd7e4' : '#fafafa',
}))

export const VibrantText = styled('p')(({ isActive = false }) => ({
  padding: 12,
  margin: 'auto',
  fontFamily,
  fontWeight: 600,
  fontSize: 14,
  lineHeight: '20.5px',
  WebkitTextStrokeColor: teal,
  WebkitTextStrokeWidth: '0px',
  borderRadius: '30px',
  width: 45,
  border: isActive ? '' : `2px solid ${darkGray}`,
  backgroundColor: isActive ? navyBlue : 'transparent',
  color: isActive ? 'white' : darkGray,
}))

export const PersonalInfoTextStyle = styled('p')(({ isActive = false }) => ({
  fontFamily,
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '20.5px',
  color: isActive ? navyBlue : darkGray,
}))

export const DataRevisionContainer = styled(Row)(
  ({ backgroundColor = 'white' }) => ({
    boxSizing: 'border-box',
    padding: '16px 15px 153px',
    marginTop: '16px',
    backgroundColor,
  }),
)

export const ProfileInfoDataValidationMessage = styled('p')({
  padding: 0,
  margin: 0,
  font: '600 14px/20.5px Poppins, sans-serif',
  color: darkGray,
})

export const ProfileInfoFormContainer = styled('div')({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'center',
  width: '100%',
  paddingRight: 12,
  marginTop: 16,
})
